import { createSlice } from "@reduxjs/toolkit";

export const serviceSlice = createSlice({
  name: "service",
  initialState: {
    services: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    addServiceStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    addServiceSuccess: (state, action) => {
      state.isFetching = false;
      state.services.push(action.payload);
      if (Array.isArray(state.services)) {
        state.services.push(action.payload.data);
      } else {
        // fallback if games is undefined or not array
        state.services = [action.payload.data];
      }
    },
    addServiceFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    getServiceStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getServiceSuccess: (state, action) => {
      state.isFetching = false;
      state.services = action.payload;
    },
    getServiceFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    // UPDATE
    updateServiceStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    updateServiceSuccess: (state, action) => {
      console.log(action.payload, 'payload in service')
      state.isFetching = false;
      state.services[
        state.services.findIndex((item) => item._id === action.payload.id)
      ] = action.payload.category;
    },
    updateServiceFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const {
  addServiceStart,
  addServiceSuccess,
  addServiceFailure,
  getServiceStart,
  getServiceSuccess,
  getServiceFailure,
  updateServiceStart,
  updateServiceSuccess,
  updateServiceFailure
} = serviceSlice.actions;

export default serviceSlice.reducer;
